import React, { useState } from "react";
import Switch from "react-input-switch";

const SwitchHotkey = (className = "") => {
  let msgHotkey;

  if (localStorage.getItem("hotkeyToggle") === null) {
    msgHotkey = "Ctrl";
  } else {
    msgHotkey = localStorage.getItem("hotkeyToggle");
  }

  const [value, setValue] = useState(msgHotkey);

  function handleChange(e) {
    setValue(e);
    localStorage.setItem("hotkeyToggle", e);
  }

  return (
    <Switch
      className={className}
      on="Enter"
      off="Ctrl"
      value={value}
      onChange={handleChange}
    />
  );
};
export default SwitchHotkey;
